import template from './contactLiabilitiesList.template.html';

export default {
  template,
  bindings: {
    liabilities: '<',
    lenders: '<',
    contacts: '<',
    assets: '<',
    documents: '<',
    otherDateFormat: '<',
    onEdit: '&',
    onDelete: '&',
    onReady: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, listServiceNew, liabilitiesService, helperService) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.natural = $rootScope.natural;
      ctrl.organizationCountry = null;
      ctrl.currentCurrency = null;
      ctrl.currentDateFormat = null;
      ctrl.currentTimeZone = null;
      ctrl.currentLocale = null;
      ctrl.list = new listServiceNew.List();
      ctrl.list.clear();

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.list.setData(ctrl.liabilities);
        ctrl.onReady({ list: ctrl.list });
      };

      ctrl.liabilityEdit = ($event, data) => {
        ctrl.onEdit({ event: $event, data });
      };

      ctrl.liabilityDelete = ($event, data) => {
        ctrl.onDelete({ event: $event, data });
      };

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.contacts.length) {
          contact = ctrl.contacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      ctrl.getAssetName = (idAsset) => {
        const asset = _.find(ctrl.assets, (a) => a.id === idAsset || a.idReference === idAsset);
        return asset?.getName() || '-';
      };

      ctrl.getLenderDocument = (abbr) => {
        let doc;
        if (ctrl.documents.length) {
          doc = ctrl.documents.find(
            (d) => d.lender[0].abbr.toLowerCase() === abbr && d.type.indexOf('LOGO') > -1
          );
        }
        return doc ? doc.url : '';
      };

      ctrl.getLiabilityName = (liability) => {
        if (ctrl.isLiabilityTypeLoan(liability) || ctrl.isLiabilityTypeCreditCard(liability)) {
          return (
            ctrl.lenders.find((d) => d.abbr.toLowerCase() === liability.name)?.name || 'N/A'
          );
        }
        return liability.getName();
      };

      ctrl.isLiabilityTypeLoan = (liability) =>
        helperService.isLiabilityTypeLoan(liability.liabilityType);

      ctrl.isLiabilityTypeMortgageOrVehicleOrSmsf = (liability) =>
        helperService.isLiabilityTypeMortgageOrVehicleOrSmsf(liability.liabilityType);

      ctrl.isLiabilityTypeMortgageOrSmsfLoan = (liability) =>
        helperService.isLiabilityTypeMortgageOrSmsfLoan(liability.liabilityType);

      ctrl.isLiabilityTypeMortgage = (liability) =>
        helperService.isLiabilityTypeMortgage(liability.liabilityType);

      ctrl.isLiabilityTypeCreditCard = (liability) =>
        helperService.isLiabilityTypeCreditCard(liability.liabilityType);

      ctrl.isLiabilityTypeOverDraft = (liability) =>
        helperService.isLiabilityTypeOverDraft(liability.liabilityType);

      ctrl.isLiabilityTypeVehicle = (liability) =>
        helperService.isLiabilityTypeVehicle(liability.liabilityType);

      ctrl.isLiabilityTypePersonal = (liability) =>
        helperService.isLiabilityTypePersonal(liability.liabilityType);

      ctrl.isLiabilityTypeSmsf = (liability) =>
        helperService.isLiabilityTypeSmsf(liability.liabilityType);

      ctrl.isLiabilityTypeEducationDebt = (liability) =>
        helperService.isLiabilityTypeEducationDebt(liability.liabilityType);

      ctrl.isLiabilityTypeOther = (liability) =>
        helperService.isLiabilityTypeOther(liability.liabilityType);

      ctrl.isLiabilityTypeBalanceSheet = (liability) =>
        helperService.isLiabilityTypeBalanceSheet(liability.liabilityType);

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.liabilities) {
          ctrl.initialize();
        }
      };
    }
  }
};
